module.exports = __webpack_public_path__ + "Flaticon.03ce791070f36e3df664.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/global-css/fonts/font/Flaticon.woff
// module id = ./src/app/global-css/fonts/font/Flaticon.woff
// module chunks = main